/** @jsx jsx */
import { css } from '@emotion/core';
import { typography } from '../../../styles/typography';
import { MediaQueries } from '../../../styles/Grid';

export const wrapper = css({
  width: '100vw',
  overflow: 'hidden',
  backgroundColor: '#F4F3F0',
  display: 'flex',
  position: 'relative',
});

export const container = css({
  width: '100vw',
  display: 'flex',
  overflow: 'hidden',
  alignItems: 'center',
  justifyContent: 'space-between',
  position: 'relative',
  transition: '1s',
  '::-webkit-transition': '1s',
  [MediaQueries.sm]: {
    flexDirection: 'column',
  },
});

export const containerMoved = css(container, {
  transform: 'translateX(-50vw)',
});

export const containerMovedOver = css(container, {
  transform: 'translateX(-100vw)',
});

export const itemsSubContainer = css({
  height: '100%',
  overflowY: 'hidden',
  position: 'relative',
});

export const itemsSubContainerSelected = css(itemsSubContainer, {
  overflowY: 'scroll',
});

export const itemsSubContainerAbsolute = css({
  position: 'absolute',
});

export const itemsContainer = css({
  flex: '1',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: '0 10%',
  height: '100vh',
  position: 'relative',
});

export const itemsContainerMoved = css(itemsContainer, {
  transform: 'translateX(-50vw)',
});

export const titleContainer = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: '10vh 10vw',
  transition: '1s',
  '::-webkit-transition': '1s',
});

export const titleContainerMoved = css(titleContainer, {
  transform: 'translateX(-50vw)',
});

export const title = css({
  fontSize: '48px',
  fontWeight: 500,
  marginBottom: '24px',
});

export const subTitle = css(typography.effra18, {});

export const cardContainer = css({
  display: 'flex',
  padding: '10px 20px',
  backgroundColor: '#fff',
  gap: '16px',
  width: '304px',
  marginBottom: '20px',
  cursor: 'pointer',
  borderRadius: '8px',
  position: 'relative',
});

export const cardContainerSelected = css(cardContainer, {});

export const cardSelector = css({
  position: 'absolute',
  width: '3px',
  top: '10%',
  height: '80%',
  right: '0px',
  backgroundColor: '#f00',
});

export const cardImage = css({
  width: '14px',
});

export const cardTitle = css({
  fontSize: '18px',
  marginBottom: '14px',
});

export const cardLink = css({
  color: '#E52500',
});

export const backLink = css({
  position: 'absolute',
  left: '-60vw',
  fontSize: '16px',
  padding: '15px',
  transition: '1s',
  '::-webkit-transition': '1s',
  cursor: 'pointer',
});

export const backLinkShowed = css(backLink, {
  transform: 'translateX(65vw)',
});

export const itemContent = css({
  width: '50vw',
  height: '100vh',
  position: 'absolute',
  left: '100vw',
  transition: '1s',
  '::-webkit-transition': '1s',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const itemContentShowed = css(itemContent, {
  transform: 'translateX(-50vw)',
});

export const itemContentShowedFully = css(itemContent, {
  transform: 'translateX(-100vw)',
});

export const flexed = css({
  flex: 1,
});

export const fixedContainer = css({
  position: 'fixed',
});

export const width100 = css({
  width: '100vw',
});

export const fixedBack = css({
  top: '10px',
  left: '-500px',
  position: 'fixed',
  transition: '1s',
  '::-webkit-transition': '1s',
});

export const fixedBackShowed = css(fixedBack, {
  left: '10px',
});

export const fadedTop = css({
  top: '0',
  height: '80px',
  width: '100%',
  position: 'absolute',
  background:
    'linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(244,243,240,1) 100%)',
});

export const fadedBottom = css({
  bottom: '0',
  height: '80px',
  width: '100%',
  position: 'absolute',
  background:
    'linear-gradient(0deg, rgba(244,243,240,1) 0%, rgba(255,255,255,0) 100%)',
});

export const bolded = css({
  fontWeight: 'bold',
});
